import { useParams } from 'react-router';
import { OrderDetail } from './OrderDetail';

export function OrderDetailPage() {
  const { id } = useParams();
  return <OrderDetail id={id!} />;
}
